var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgRetailColored = function SvgRetailColored(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#6161FF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    clipPath: "url(#clip0_878_1279)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.143 12.143v6.429a.715.715 0 0 0 .714.714h14.286a.715.715 0 0 0 .714-.715v-6.428M11.428 12.143v7.143M2.143 14.286h9.285M.714 5.714l2.143-5h14.286l2.143 5zM6.828 5.714v1.429A2.857 2.857 0 0 1 3.971 10h-.4A2.857 2.857 0 0 1 .714 7.143V5.714"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.214 5.714v1.429A2.857 2.857 0 0 1 10.357 10h-.715a2.857 2.857 0 0 1-2.857-2.857V5.714M19.286 5.714v1.429A2.857 2.857 0 0 1 16.428 10h-.357a2.857 2.857 0 0 1-2.857-2.857V5.714"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_878_1279"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })))));
};
export default SvgRetailColored;